module.exports = __webpack_public_path__ + "public/Icons/womanIcon.svg?5bee1794";